(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7173],{

/***/ 3629:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/objects",
      function () {
        return __webpack_require__(4111);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7333);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(637);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1121);
/* harmony import */ var _Textarea__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3639);
/* harmony import */ var _styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1102);
/* harmony import */ var _styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var shakeEl = function(el) {
    el.animate([
        {
            transform: "translate3d(-2px, 0, 0)"
        },
        {
            transform: "translate3d(2px, 0, 0)"
        },
        {
            transform: "translate3d(-5px, 0, 0)"
        },
        {
            transform: "translate3d(5px, 0, 0)"
        },
        {
            transform: "translate3d(0, 0, 0)"
        }
    ], 200);
};
var Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2280).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var Splitter = function(param) {
    var title = param.title, subtitle = param.subtitle;
    /** STATES */ var locationState = (0,_context_location__WEBPACK_IMPORTED_MODULE_5__/* .useLocationState */ .KJ)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isModalFeedbackVisible = ref[0], setIsModalFeedbackVisible = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isModalSuccessVisible = ref1[0], setIsModalSuccessVisible = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), clientName = ref2[0], setClientName = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), clientPhone = ref3[0], setClientPhone = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), clientComment = ref4[0], setClientComment = ref4[1];
    var clientNameId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var clientPhoneId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var inputParentId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var inputId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    /** HANDLERS */ var handleFeedbackClick = function() {
        if (clientPhone.length === 11) setIsModalFeedbackVisible(true);
        else shakeEl(inputParentId.current);
    };
    var handleFormSubmit = function() {
        clientNameId.current.setError(clientName.length <= 3);
        clientPhoneId.current.setError(clientPhone.length !== 11);
        if (clientName.length > 3 && clientPhone.length === 11) {
            setIsModalFeedbackVisible(false);
            setIsModalSuccessVisible(true);
            axios__WEBPACK_IMPORTED_MODULE_3___default().post("https://baza.estate/api/v2" + "/client", {
                clientName: clientName,
                clientPhone: clientPhone,
                clientComment: clientComment,
                pathName: window.location.pathname,
                whatComponent: "Splitter",
                location: locationState.region,
                platform: "web"
            });
            inputId.current.value = "";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Modal, {
                title: "Обратная связь",
                visibility: isModalSuccessVisible,
                onClose: function() {
                    return setIsModalSuccessVisible(false);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            marginBottom: 18
                        },
                        children: "Спасибо за вашу заявку. Мы скоро с Вами свяжемся!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/images/man-with-message.svg",
                        alt: "",
                        style: {
                            margin: 32
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Modal, {
                title: "Обратная связь",
                button: "Отправить",
                action: handleFormSubmit,
                visibility: isModalFeedbackVisible,
                onClose: function() {
                    return setIsModalFeedbackVisible(false);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            marginBottom: 18
                        },
                        children: "Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, поможем решить все имеющиеся у Вас вопросы!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        title: "Имя",
                        inputs: [
                            {
                                placeholder: "Иван Петрович",
                                value: clientName,
                                type: "text"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientNameId,
                        onChange: function(v) {
                            return setClientName(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        title: "Телефон",
                        inputs: [
                            {
                                placeholder: locationState.phone,
                                value: clientPhone,
                                mask: "phone",
                                type: "tel"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientPhoneId,
                        onChange: function(v) {
                            return setClientPhone(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Textarea__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        title: "Коммментарий",
                        placeholder: "Например, \xabХочу получить консультацию перед продажей своей квартиры в городе\xbb",
                        autoHeight: true,
                        isWrappedStyle: true,
                        onChange: function(v) {
                            return setClientComment(v);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            textAlign: "center",
                            opacity: 0.8,
                            fontSize: 14,
                            margin: "18px 0"
                        },
                        children: [
                            "Вы соглашаетесь с",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "/faq/policy",
                                target: "_blank",
                                children: "политикой конфиденциальности"
                            }),
                            " ",
                            "при отправке данной формы к нам в работу"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "block fill clear",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: [
                        "fixed",
                        (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().splitter)
                    ].join(" "),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().text),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().subtitle),
                                    children: subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().actions),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().input),
                                    ref: inputParentId,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputZone),
                                            format: "+7 ### ### ## ##",
                                            type: "tel",
                                            placeholder: locationState.phone,
                                            getInputRef: inputId,
                                            onChange: function(e) {
                                                return setClientPhone(e.target.value.replace(/[^0-9.]/g, ""));
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputButton),
                                            type: "button",
                                            "aria-label": "Отправить",
                                            onClick: handleFeedbackClick,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                                                        x1: "22",
                                                        y1: "2",
                                                        x2: "11",
                                                        y2: "13"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                                        points: "22 2 15 22 11 13 2 9 22 2"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().help),
                                    children: "Введите свой номер телефона в поле выше"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
Splitter.defaultProps = {
    title: "Помочь c продажей?",
    subtitle: "Оставьте свой номер телефона и мы обязательно поможем с продажей"
};
/* harmony default export */ __webpack_exports__["Z"] = (Splitter);


/***/ }),

/***/ 3639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1319);
/* harmony import */ var _styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Textarea = function(param) {
    var title = param.title, value = param.value, placeholder = param.placeholder, isWrappedStyle = param.isWrappedStyle, isError = param.isError, autoHeight = param.autoHeight, onChange = param.onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value), txt = ref[0], setTxt = ref[1];
    var parentId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var textareaId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var handleOnClick = function() {
        if (textareaId.current) textareaId.current.focus();
    };
    var handleOnChange = function(e) {
        if (textareaId.current && autoHeight) {
            textareaId.current.style.height = "auto";
            textareaId.current.style.height = textareaId.current.scrollHeight + "px";
        }
        if (onChange) onChange(e.target.value);
        setTxt(e.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txt),
            isWrappedStyle && (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().full),
            isError && (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().error)
        ].filter(Boolean).join(" "),
        onClick: handleOnClick,
        ref: parentId,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txtTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txtContent),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                    onInput: handleOnChange,
                    ref: textareaId,
                    placeholder: placeholder,
                    children: txt
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 8171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Skelet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3177);
/* harmony import */ var _styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4062);
/* harmony import */ var _styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var ObjectsCatalogItem = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().item),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemGallery),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: {
                        height: "calc(100% - 4px)",
                        width: "auto",
                        borderRadius: 16,
                        margin: 2
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemData),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemPrice),
                        height: 46,
                        maxWidth: 200
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemAddress),
                        height: 21,
                        maxWidth: 240
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemProperties),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemProperty),
                                width: 60,
                                height: 32,
                                style: {
                                    marginRight: 12
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemProperty),
                                width: 60,
                                height: 32,
                                style: {
                                    marginRight: 12
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemProperty),
                                width: 60,
                                height: 32,
                                style: {
                                    marginRight: 12
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemDescription),
                        height: 110
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemActions),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemDate)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                width: 150,
                                height: 50,
                                style: {
                                    borderRadius: 12
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ObjectsCatalogItem);


/***/ }),

/***/ 1247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(9815);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6188);
/* harmony import */ var typeof__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typeof__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useIsMount__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9766);
/* harmony import */ var _context_objects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1563);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(637);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3725);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1121);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(360);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5113);
/* harmony import */ var _Radio__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8801);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2077);
/* harmony import */ var _styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5661);
/* harmony import */ var _styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _data_filters_json__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6014);























var valueToNormal = function(k, v) {
    if (k === "studio") return "студия";
    if (k === "rooms") return v.map(function(w) {
        return "".concat(w, "К");
    }).join(", ");
    if (k === "ceiling") return "от ".concat(v, "м");
    if (k === "priceFrom" || k === "priceTo") return "".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .moneyText */ .W8)(v));
    if (k === "squareFrom" || k === "squareTo" || k === "squareLivingFrom" || k === "squareLivingTo" || k === "squareKitchenFrom" || k === "squareKitchenTo") return "".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .spaceSplitter */ .SE)(v, 3), " м\xb2");
    if (k === "squareAreaFrom" || k === "squareAreaTo") return "".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .spaceSplitter */ .SE)(v, 3), " сот");
    if (k === "noCommission") return "без комиссии";
    if (k === "exclusive") return "только у нас";
    if (typeof__WEBPACK_IMPORTED_MODULE_4___default()(v) === "string") return v;
    if (typeof__WEBPACK_IMPORTED_MODULE_4___default()(v) === "array") return v.join(", ");
    return "";
};
var getLocality = function(k) {
    return objectsState.reference.locality;
    return [];
};
var getDistricts = function(k) {
    return [];
};
var countOfMoreFilters = function(s) {
    var arrMoreFilters = [
        "squareLivingFrom",
        "squareLivingTo",
        "squareKitchenFrom",
        "squareKitchenTo",
        "floorFrom",
        "floorTo",
        "floorsFrom",
        "floorsTo",
        "ceiling",
        "balcony",
        "renovation",
        "bathroom",
        "buildingType",
        "stock",
        "lotType",
        "subCategory",
        "entrance",
        "commercialBuildingType"
    ];
    var moreFiltersCount = 0;
    for(var i = 0; i < arrMoreFilters.length; i++)if (s[arrMoreFilters[i]] && s[arrMoreFilters[i]].length) moreFiltersCount++;
    return moreFiltersCount;
};
var countOfFilters = function(s) {
    var arrMainFilters = [
        "priceFrom",
        "priceTo",
        "rooms",
        "studio",
        "squareFrom",
        "squareTo",
        "mikroraion",
        "locality",
        "squareAreaFrom",
        "squareAreaTo",
        "commercialType",
        "noCommission",
        "exclusive"
    ];
    var mainFiltersCount = 0;
    for(var i = 0; i < arrMainFilters.length; i++)if (s[arrMainFilters[i]] && (s[arrMainFilters[i]].length || s[arrMainFilters[i]] > 0)) mainFiltersCount++;
    return countOfMoreFilters(s) + mainFiltersCount;
};
var isAnyFilters = function(s) {
    var arrFilters = [
        "priceFrom",
        "priceTo",
        "rooms",
        "studio",
        "squareFrom",
        "squareTo",
        "mikroraion",
        "locality",
        "noCommission",
        "exclusive",
        "squareAreaFrom",
        "squareAreaTo",
        "commercialType",
        "squareLivingFrom",
        "squareLivingTo",
        "squareKitchenFrom",
        "squareKitchenTo",
        "floorFrom",
        "floorTo",
        "floorsFrom",
        "floorsTo",
        "ceiling",
        "balcony",
        "renovation",
        "bathroom",
        "buildingType",
        "stock",
        "lotType",
        "subCategory",
        "entrance",
        "commercialBuildingType"
    ];
    var filtersTotal = 0;
    for(var i = 0; i < arrFilters.length; i++)if (s[arrFilters[i]] && (s[arrFilters[i]].length || s[arrFilters[i]] > 0)) filtersTotal++;
    return filtersTotal > 0;
};
var ObjectsFilter = function() {
    /** STATES */ var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var isMount = (0,_hooks_useIsMount__WEBPACK_IMPORTED_MODULE_6__/* .useIsMount */ .z)();
    var locationState = (0,_context_location__WEBPACK_IMPORTED_MODULE_8__/* .useLocationState */ .KJ)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_context_objects__WEBPACK_IMPORTED_MODULE_7__/* .useObjectsProvider */ .v8)(), 2), objectsState = ref[0], setObjectsState = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(countOfMoreFilters(objectsState.filter) > 0), isMoreVisible = ref[0], setIsMoreVisible = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(countOfMoreFilters(objectsState.filter)), moreFiltersCount = ref[0], setMoreFiltersCount = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(countOfFilters(objectsState.filter)), filtersCount = ref[0], setFiltersCount = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), foundCount = ref[0], setFoundCount = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.type), type = ref[0], setType = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.category), category = ref[0], setCategory = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.priceFrom), priceFrom = ref[0], setPriceFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.priceTo), priceTo = ref[0], setPriceTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.noCommission), noCommission = ref[0], setNoCommission = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.exclusive), exclusive = ref[0], setExclusive = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.mikroraion), district = ref[0], setDistrict = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.locality), locality = ref[0], setLocality = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.studio), studio = ref[0], setStudio = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.rooms), rooms = ref[0], setRooms = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.squareFrom), squareFrom = ref[0], setSquareFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.squareTo), squareTo = ref[0], setSquareTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.squareAreaFrom), squareAreaFrom = ref[0], setSquareAreaFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.squareAreaTo), squareAreaTo = ref[0], setSquareAreaTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.commercialType), commercialType = ref[0], setCommercialType = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.squareLivingFrom), squareLivingFrom = ref[0], setSquareLivingFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.squareLivingTo), squareLivingTo = ref[0], setSquareLivingTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.squareKitchenFrom), squareKitchenFrom = ref[0], setSquareKitchenFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.squareKitchenTo), squareKitchenTo = ref[0], setSquareKitchenTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.balcony), balcony = ref[0], setBalcony = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.ceiling), ceiling = ref[0], setCeiling = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.floorFrom), floorFrom = ref[0], setFloorFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.floorTo), floorTo = ref[0], setFloorTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.floorsFrom), floorsFrom = ref[0], setFloorsFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.floorsTo), floorsTo = ref[0], setFloorsTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.renovation), renovation = ref[0], setRenovation = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.buildingType), buildingType = ref[0], setBuildingType = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.bathroom), bathroom = ref[0], setBathroom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.stock), stock = ref[0], setStock = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.lotType), lotType = ref[0], setLotType = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.subCategory), subCategory = ref[0], setSubCategory = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.entrance), entrance = ref[0], setEntrance = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(objectsState.filter.commercialBuildingType), commercialBuildingType = ref[0], setCommercialBuildingType = ref[1];
    /** FUNCTIONS */ var handleSearchClick = function() {
        var newFilterSearch = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, objectsState.filter);
        newFilterSearch.type = type;
        newFilterSearch.category = category;
        newFilterSearch.priceFrom = priceFrom;
        newFilterSearch.priceTo = priceTo;
        newFilterSearch.studio = [
            "квартира"
        ].includes(category) ? studio : 0;
        newFilterSearch.rooms = [
            "квартира"
        ].includes(category) ? rooms : [];
        newFilterSearch.squareFrom = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? squareFrom : "";
        newFilterSearch.squareTo = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? squareTo : "";
        newFilterSearch.squareAreaFrom = [
            "дом",
            "участок"
        ].includes(category) ? squareAreaFrom : "";
        newFilterSearch.squareAreaTo = [
            "дом",
            "участок"
        ].includes(category) ? squareAreaTo : "";
        newFilterSearch.commercialType = [
            "коммерция"
        ].includes(category) ? commercialType : [];
        newFilterSearch.mikroraion = district;
        newFilterSearch.locality = locality;
        newFilterSearch.noCommission = noCommission;
        newFilterSearch.exclusive = exclusive;
        newFilterSearch.squareLivingFrom = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? squareLivingFrom : "";
        newFilterSearch.squareLivingTo = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? squareLivingTo : "";
        newFilterSearch.squareKitchenFrom = [
            "квартира",
            "дом"
        ].includes(category) ? squareKitchenFrom : "";
        newFilterSearch.squareKitchenTo = [
            "квартира",
            "дом"
        ].includes(category) ? squareKitchenTo : "";
        newFilterSearch.floorFrom = [
            "квартира",
            "комната",
            "коммерция"
        ].includes(category) ? floorFrom : "";
        newFilterSearch.floorTo = [
            "квартира",
            "комната",
            "коммерция"
        ].includes(category) ? floorTo : "";
        newFilterSearch.floorsFrom = [
            "квартира",
            "комната",
            "дом",
            "коммерция"
        ].includes(category) ? floorsFrom : "";
        newFilterSearch.floorsTo = [
            "квартира",
            "комната",
            "дом",
            "коммерция"
        ].includes(category) ? floorsTo : "";
        newFilterSearch.ceiling = [
            "квартира",
            "комната",
            "дом",
            "коммерция"
        ].includes(category) ? ceiling : "";
        newFilterSearch.balcony = [
            "квартира",
            "комната"
        ].includes(category) ? balcony : [];
        newFilterSearch.renovation = [
            "квартира",
            "комната",
            "дом",
            "коммерция"
        ].includes(category) ? renovation : [];
        newFilterSearch.bathroom = [
            "квартира",
            "комната"
        ].includes(category) ? bathroom : [];
        newFilterSearch.buildingType = [
            "квартира",
            "комната",
            "дом"
        ].includes(category) ? buildingType : [];
        newFilterSearch.stock = [
            "квартира",
            "комната"
        ].includes(category) ? stock : [];
        newFilterSearch.lotType = [
            "дом",
            "участок"
        ].includes(category) ? lotType : [];
        newFilterSearch.subCategory = [
            "дом"
        ].includes(category) ? subCategory : [];
        newFilterSearch.entrance = [
            "коммерция"
        ].includes(category) ? entrance : [];
        newFilterSearch.commercialBuildingType = [
            "коммерция"
        ].includes(category) ? commercialBuildingType : [];
        //newFilterSearch.location = locationState.region;
        setObjectsState({
            type: "SET_PAGINATION",
            payload: {}
        });
        setObjectsState({
            type: "SET_FILTER",
            payload: newFilterSearch
        });
    };
    var handleResetClick = function() {
        setPriceFrom("");
        setPriceTo("");
        setNoCommission(0);
        setExclusive(0);
        setLocality([]);
        setDistrict([]);
        setStudio(0);
        setRooms([]);
        setSquareFrom("");
        setSquareTo("");
        setSquareAreaFrom("");
        setSquareAreaTo("");
        setCommercialType([]);
        setSquareLivingFrom("");
        setSquareLivingTo("");
        setSquareKitchenFrom("");
        setSquareKitchenTo("");
        setBalcony([]);
        setCeiling("");
        setFloorFrom("");
        setFloorTo("");
        setFloorsFrom("");
        setFloorsTo("");
        setRenovation([]);
        setBuildingType([]);
        setBathroom([]);
        setStock([]);
        setLotType([]);
        setSubCategory([]);
        setEntrance([]);
        setCommercialBuildingType([]);
        setObjectsState({
            type: "SET_PAGINATION",
            payload: {}
        });
        setObjectsState({
            type: "SET_FILTER",
            payload: {
                type: type,
                category: category
            }
        });
    };
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        //if (isMount) return;
        if (objectsState.reference.locality.length == 0) {
            var newReference = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, objectsState.reference);
            newReference.locality = [];
            // console.log('start');
            // console.log(locationState);
            // console.log(objectsState.reference);
            var fetchData = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var response;
                    return _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                _ctx.next = 3;
                                return axios__WEBPACK_IMPORTED_MODULE_3___default().post("https://baza.estate/api/v2" + "/objects/reference", {
                                    region: locationState.region
                                });
                            case 3:
                                response = _ctx.sent;
                                if (!(!response.data || response.data.status !== "ok")) {
                                    _ctx.next = 6;
                                    break;
                                }
                                throw new Error(response.data.text);
                            case 6:
                                if (response.data.data.location["localityName"].length > 0) {
                                    response.data.data.location["localityName"].map(function(v) {
                                        return newReference.locality.push({
                                            type: "option",
                                            text: v,
                                            value: v
                                        });
                                    });
                                    setObjectsState({
                                        type: "SET_REFERENCE",
                                        payload: newReference
                                    });
                                //console.log(objectsState);
                                }
                                _ctx.next = 11;
                                break;
                            case 9:
                                _ctx.prev = 9;
                                _ctx.t0 = _ctx["catch"](0);
                            case 11:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            9
                        ]
                    ]);
                }));
                return function fetchData() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchData();
        // console.log(newReference);
        // console.log('super end fetch');
        }
    }, [
        locality
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isMount) return;
        var newLink = [
            "/",
            router.query.region,
            "/objects"
        ].join("");
        switch(objectsState.filter.type){
            default:
            case "продажа":
                newLink += "/buy";
                break;
            case "аренда":
                newLink += "/rent";
                break;
        }
        switch(objectsState.filter.category){
            default:
            case "квартира":
                newLink += "/flats";
                break;
            case "комната":
                newLink += "/rooms";
                break;
            case "дом":
                newLink += "/houses";
                break;
            case "участок":
                newLink += "/sites";
                break;
            case "коммерция":
                newLink += "/commercial";
                break;
        }
        if (objectsState.filter.category === "квартира") {
            if (objectsState.filter.rooms.length === 0 && objectsState.filter.studio) newLink += "/studio";
            if (objectsState.filter.rooms.length === 1 && !objectsState.filter.studio) newLink += "/".concat(objectsState.filter.rooms[0], "k");
        }
        var newUri = "".concat(newLink).concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .JSONToQuery */ .vp)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, objectsState.filter, objectsState.pagination, objectsState.sorting), [
            "type",
            "category",
            "length",
            objectsState.filter.studio && !objectsState.filter.rooms.length && "studio",
            !objectsState.filter.studio && objectsState.filter.rooms.length === 1 && "rooms"
        ], [
            "page=1",
            "sort=last-update.date"
        ]));
        router.replace(newUri, undefined, {
            scroll: false
        });
        setMoreFiltersCount(countOfMoreFilters(objectsState.filter));
        setFiltersCount(countOfFilters(objectsState.filter));
        if (!countOfMoreFilters(objectsState.filter)) setIsMoreVisible(false);
    }, [
        objectsState.filter,
        objectsState.pagination
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!locationState.isLoaded) return;
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response;
                return _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            _ctx.next = 3;
                            return (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .sleep */ ._v)(300);
                        case 3:
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return axios__WEBPACK_IMPORTED_MODULE_3___default().post("https://baza.estate/api/v2" + "/objects", {
                                type: type,
                                category: category,
                                priceFrom: priceFrom,
                                priceTo: priceTo,
                                studio: [
                                    "квартира"
                                ].includes(category) ? studio : 0,
                                rooms: [
                                    "квартира"
                                ].includes(category) ? rooms : [],
                                squareFrom: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? squareFrom : "",
                                squareTo: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? squareTo : "",
                                squareAreaFrom: [
                                    "дом",
                                    "участок"
                                ].includes(category) ? squareAreaFrom : "",
                                squareAreaTo: [
                                    "дом",
                                    "участок"
                                ].includes(category) ? squareAreaTo : "",
                                commercialType: [
                                    "коммерция"
                                ].includes(category) ? commercialType : [],
                                mikroraion: district,
                                locality: locality,
                                noCommission: noCommission,
                                exclusive: exclusive,
                                squareLivingFrom: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? squareLivingFrom : "",
                                squareLivingTo: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? squareLivingTo : "",
                                squareKitchenFrom: [
                                    "квартира",
                                    "дом"
                                ].includes(category) ? squareKitchenFrom : "",
                                squareKitchenTo: [
                                    "квартира",
                                    "дом"
                                ].includes(category) ? squareKitchenTo : "",
                                floorFrom: [
                                    "квартира",
                                    "комната",
                                    "коммерция"
                                ].includes(category) ? floorFrom : "",
                                floorTo: [
                                    "квартира",
                                    "комната",
                                    "коммерция"
                                ].includes(category) ? floorTo : "",
                                floorsFrom: [
                                    "квартира",
                                    "комната",
                                    "дом",
                                    "коммерция"
                                ].includes(category) ? floorsFrom : "",
                                floorsTo: [
                                    "квартира",
                                    "комната",
                                    "дом",
                                    "коммерция"
                                ].includes(category) ? floorsTo : "",
                                ceiling: [
                                    "квартира",
                                    "комната",
                                    "дом",
                                    "коммерция"
                                ].includes(category) ? ceiling : "",
                                balcony: [
                                    "квартира",
                                    "комната"
                                ].includes(category) ? balcony : [],
                                renovation: [
                                    "квартира",
                                    "комната",
                                    "дом",
                                    "коммерция"
                                ].includes(category) ? renovation : [],
                                bathroom: [
                                    "квартира",
                                    "комната"
                                ].includes(category) ? bathroom : [],
                                buildingType: [
                                    "квартира",
                                    "комната",
                                    "дом"
                                ].includes(category) ? buildingType : [],
                                stock: [
                                    "квартира",
                                    "комната"
                                ].includes(category) ? stock : [],
                                lotType: [
                                    "дом",
                                    "участок"
                                ].includes(category) ? lotType : [],
                                subCategory: [
                                    "дом"
                                ].includes(category) ? subCategory : [],
                                entrance: [
                                    "коммерция"
                                ].includes(category) ? entrance : [],
                                commercialBuildingType: [
                                    "коммерция"
                                ].includes(category) ? commercialBuildingType : [],
                                location: locationState.region,
                                stat: 1
                            }, {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setFoundCount(response.data.data.count);
                            setIsLoading(false);
                            _ctx.next = 15;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](3);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        13
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        locationState,
        type,
        category,
        priceFrom,
        priceTo,
        noCommission,
        exclusive,
        district,
        studio,
        rooms,
        squareFrom,
        squareTo,
        squareAreaFrom,
        squareAreaTo,
        commercialType,
        squareLivingFrom,
        squareLivingTo,
        squareKitchenFrom,
        squareKitchenTo,
        balcony,
        ceiling,
        floorFrom,
        floorTo,
        floorsFrom,
        floorsTo,
        renovation,
        buildingType,
        bathroom,
        stock,
        lotType,
        subCategory,
        entrance,
        commercialBuildingType
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: [
            "block",
            (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().block)
        ].join(" "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "fixed",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterWrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterGroup),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Radio__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Тип сделки",
                                        radios: [
                                            {
                                                text: "Купить",
                                                value: "продажа"
                                            },
                                            {
                                                text: "Снять",
                                                value: "аренда",
                                                disabled: category === "участок"
                                            }
                                        ],
                                        selected: type,
                                        onChange: function(v) {
                                            setType(v);
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, objectsState.filter), {
                                                    type: v
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Radio__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "Категория объекта",
                                        radios: [
                                            {
                                                text: "Квартира",
                                                value: "квартира"
                                            },
                                            {
                                                text: "Комната",
                                                value: "комната"
                                            },
                                            {
                                                text: "Дом",
                                                value: "дом"
                                            },
                                            {
                                                text: "Участок",
                                                value: "участок",
                                                disabled: type === "аренда"
                                            },
                                            {
                                                text: "Коммерция",
                                                value: "коммерция"
                                            }
                                        ],
                                        selected: category,
                                        onChange: function(v) {
                                            setCategory(v);
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, objectsState.filter), {
                                                    category: v
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        title: "Стоимость",
                                        inputs: [
                                            {
                                                placeholder: "Цена от",
                                                mask: "money",
                                                value: priceFrom,
                                                max: 99999999
                                            },
                                            {
                                                placeholder: "Цена до",
                                                mask: "money",
                                                value: priceTo,
                                                max: 99999999
                                            }
                                        ],
                                        onChange: function(v) {
                                            setPriceFrom(v[0]);
                                            setPriceTo(v[1]);
                                        },
                                        suffix: "₽"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        title: "Количество комнат",
                                        checkboxes: [
                                            {
                                                text: "Студия",
                                                value: "студия"
                                            },
                                            {
                                                text: "1К",
                                                value: "1"
                                            },
                                            {
                                                text: "2К",
                                                value: "2"
                                            },
                                            {
                                                text: "3К",
                                                value: "3"
                                            },
                                            {
                                                text: "4К+",
                                                value: "4"
                                            }
                                        ],
                                        visibility: [
                                            "квартира"
                                        ].includes(category),
                                        selected: studio ? [
                                            "студия"
                                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(rooms)) : rooms,
                                        onChange: function(v) {
                                            if (v.includes("студия")) setStudio(1);
                                            else setStudio(0);
                                            setRooms(v.filter(function(x) {
                                                return x !== "студия";
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        title: "Общая площадь",
                                        inputs: [
                                            {
                                                placeholder: "Площадь от",
                                                mask: "number",
                                                value: squareFrom,
                                                max: 999999
                                            },
                                            {
                                                placeholder: "Площадь до",
                                                mask: "number",
                                                value: squareTo,
                                                max: 999999
                                            }
                                        ],
                                        visibility: [
                                            "квартира",
                                            "комната",
                                            "дом"
                                        ].includes(category),
                                        suffix: "м\xb2",
                                        onChange: function(v) {
                                            setSquareFrom(v[0]);
                                            setSquareTo(v[1]);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        title: "Площадь участка",
                                        inputs: [
                                            {
                                                placeholder: "Площадь от",
                                                mask: "number",
                                                value: squareAreaFrom,
                                                max: 999999
                                            },
                                            {
                                                placeholder: "Площадь до",
                                                mask: "number",
                                                value: squareAreaTo,
                                                max: 999999
                                            }
                                        ],
                                        visibility: [
                                            "дом",
                                            "участок"
                                        ].includes(category),
                                        suffix: "сот",
                                        onChange: function(v) {
                                            setSquareAreaFrom(v[0]);
                                            setSquareAreaTo(v[1]);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        title: "Назначение объекта",
                                        options: [
                                            {
                                                type: "option",
                                                text: "Автосервис",
                                                value: "автосервис"
                                            },
                                            {
                                                type: "option",
                                                text: "Гостиница",
                                                value: "гостиница"
                                            },
                                            {
                                                type: "option",
                                                text: "Готовый бизнес",
                                                value: "готовый бизнес"
                                            },
                                            {
                                                type: "option",
                                                text: "Коммерческая земля",
                                                value: "коммерческая земля"
                                            },
                                            {
                                                type: "option",
                                                text: "Общепит",
                                                value: "общепит"
                                            },
                                            {
                                                type: "option",
                                                text: "Офисное помещение",
                                                value: "офисное помещение"
                                            },
                                            {
                                                type: "option",
                                                text: "ПСН",
                                                value: "псн"
                                            },
                                            {
                                                type: "option",
                                                text: "Производственное помещение",
                                                value: "производственное помещение"
                                            },
                                            {
                                                type: "option",
                                                text: "Склад",
                                                value: "склад"
                                            },
                                            {
                                                type: "option",
                                                text: "Торговое помещение",
                                                value: "торговое помещение"
                                            }
                                        ],
                                        selected: commercialType,
                                        visibility: [
                                            "коммерция"
                                        ].includes(category),
                                        multiple: true,
                                        onChange: function(v) {
                                            setCommercialType(v);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterLine),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                title: "Город",
                                                options: objectsState.reference.locality,
                                                selected: locality,
                                                multiple: true,
                                                onChange: function(v) {
                                                    setLocality(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                title: "Акции",
                                                checkboxes: [
                                                    {
                                                        text: "Без комиссии",
                                                        value: "Без комиссии"
                                                    },
                                                    {
                                                        text: "Только у Нас",
                                                        value: "Только у Нас"
                                                    }
                                                ],
                                                selected: [
                                                    noCommission && "Без комиссии",
                                                    exclusive && "Только у Нас"
                                                ].filter(function(x) {
                                                    return x;
                                                }),
                                                onChange: function(v) {
                                                    setNoCommission(Number(v.includes("Без комиссии")));
                                                    setExclusive(Number(v.includes("Только у Нас")));
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isMoreVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterSplit)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterGroup),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                title: "Жилая площадь",
                                                inputs: [
                                                    {
                                                        placeholder: "Площадь от",
                                                        mask: "number",
                                                        value: squareLivingFrom,
                                                        max: 999999
                                                    },
                                                    {
                                                        placeholder: "Площадь до",
                                                        mask: "number",
                                                        value: squareLivingTo,
                                                        max: 999999
                                                    }
                                                ],
                                                visibility: [
                                                    "квартира",
                                                    "комната",
                                                    "дом"
                                                ].includes(category),
                                                suffix: "м\xb2",
                                                onChange: function(v) {
                                                    setSquareLivingFrom(v[0]);
                                                    setSquareLivingTo(v[1]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                title: "Кухонная площадь",
                                                inputs: [
                                                    {
                                                        placeholder: "Площадь от",
                                                        mask: "number",
                                                        value: squareKitchenFrom,
                                                        max: 999999
                                                    },
                                                    {
                                                        placeholder: "Площадь до",
                                                        mask: "number",
                                                        value: squareKitchenTo,
                                                        max: 999999
                                                    }
                                                ],
                                                visibility: [
                                                    "квартира",
                                                    "дом"
                                                ].includes(category),
                                                suffix: "м\xb2",
                                                onChange: function(v) {
                                                    setSquareKitchenFrom(v[0]);
                                                    setSquareKitchenTo(v[1]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                title: "Балкон",
                                                checkboxes: [
                                                    {
                                                        text: "Балкон",
                                                        value: "балкон"
                                                    },
                                                    {
                                                        text: "Лоджия",
                                                        value: "лоджия"
                                                    }
                                                ],
                                                selected: balcony,
                                                visibility: [
                                                    "квартира",
                                                    "комната"
                                                ].includes(category),
                                                onChange: function(v) {
                                                    setBalcony(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                title: "Высота потолков",
                                                checkboxes: [
                                                    {
                                                        text: "от 2.5м",
                                                        value: "2.5"
                                                    },
                                                    {
                                                        text: "от 2.7м",
                                                        value: "2.7"
                                                    },
                                                    {
                                                        text: "от 3м",
                                                        value: "3"
                                                    },
                                                    {
                                                        text: "от 4м",
                                                        value: "4"
                                                    }
                                                ],
                                                single: true,
                                                selected: ceiling,
                                                visibility: [
                                                    "квартира",
                                                    "комната",
                                                    "дом",
                                                    "коммерция"
                                                ].includes(category),
                                                onChange: function(v) {
                                                    setCeiling(v[0]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                title: "Этаж",
                                                inputs: [
                                                    {
                                                        placeholder: "Этаж от",
                                                        mask: "number",
                                                        value: floorFrom,
                                                        max: 99
                                                    },
                                                    {
                                                        placeholder: "Этаж до",
                                                        mask: "number",
                                                        value: floorTo,
                                                        max: 99
                                                    }
                                                ],
                                                visibility: [
                                                    "квартира",
                                                    "комната",
                                                    "коммерция"
                                                ].includes(category),
                                                suffix: "эт",
                                                onChange: function(v) {
                                                    setFloorFrom(v[0]);
                                                    setFloorTo(v[1]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                title: "Этажей",
                                                inputs: [
                                                    {
                                                        placeholder: "Этажей от",
                                                        mask: "number",
                                                        value: floorsFrom,
                                                        max: 999999
                                                    },
                                                    {
                                                        placeholder: "Этажей до",
                                                        mask: "number",
                                                        value: floorsTo,
                                                        max: 999999
                                                    }
                                                ],
                                                visibility: [
                                                    "квартира",
                                                    "комната",
                                                    "дом",
                                                    "коммерция"
                                                ].includes(category),
                                                suffix: "эт",
                                                onChange: function(v) {
                                                    setFloorsFrom(v[0]);
                                                    setFloorsTo(v[1]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                title: "Ремонт",
                                                options: [
                                                    {
                                                        type: "option",
                                                        text: "Дизайнерский",
                                                        value: "дизайнерский"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Евроремонт",
                                                        value: "евро"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Требует ремонта",
                                                        value: "требует ремонта"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Хороший",
                                                        value: "хороший"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Частичный ремонт",
                                                        value: "частичный ремонт"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Черновая отделка",
                                                        value: "черновая отделка"
                                                    }
                                                ],
                                                selected: renovation,
                                                visibility: [
                                                    "квартира",
                                                    "комната",
                                                    "дом",
                                                    "коммерция"
                                                ].includes(category),
                                                multiple: true,
                                                onChange: function(v) {
                                                    setRenovation(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                title: "Санузел",
                                                checkboxes: [
                                                    {
                                                        text: "Совмещенный",
                                                        value: "совмещенный"
                                                    },
                                                    {
                                                        text: "Раздельный",
                                                        value: "раздельный"
                                                    },
                                                    {
                                                        text: "Два и более",
                                                        value: "два и более"
                                                    }
                                                ],
                                                selected: bathroom,
                                                visibility: [
                                                    "квартира",
                                                    "комната"
                                                ].includes(category),
                                                onChange: function(v) {
                                                    setBathroom(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                title: "Материал стен дома",
                                                options: [
                                                    {
                                                        type: "option",
                                                        text: "Блочный",
                                                        value: "блочный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Кирпично-монолитный",
                                                        value: "кирпично-монолитный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Кирпичный",
                                                        value: "кирпичный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Монолит",
                                                        value: "монолит"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Панельный",
                                                        value: "панельный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Деревянный",
                                                        value: "деревянный"
                                                    }
                                                ],
                                                selected: buildingType,
                                                visibility: [
                                                    "квартира",
                                                    "комната",
                                                    "дом"
                                                ].includes(category),
                                                multiple: true,
                                                onChange: function(v) {
                                                    setBuildingType(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                title: "Фонд здания",
                                                options: [
                                                    {
                                                        type: "option",
                                                        text: "Коттедж",
                                                        value: "коттедж"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Новостройка",
                                                        value: "новостройка"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Современный",
                                                        value: "современный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Сталинский",
                                                        value: "сталинский"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Старый фонд",
                                                        value: "старый фонд"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Хрущевка",
                                                        value: "хрущевка"
                                                    }
                                                ],
                                                selected: stock,
                                                visibility: [
                                                    "квартира",
                                                    "комната"
                                                ].includes(category),
                                                multiple: true,
                                                onChange: function(v) {
                                                    setStock(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                title: "Тип участка",
                                                checkboxes: [
                                                    {
                                                        text: "ИЖС",
                                                        value: "ижс"
                                                    },
                                                    {
                                                        text: "Садовый",
                                                        value: "садовый"
                                                    },
                                                    {
                                                        text: "Фермерский",
                                                        value: "фермерский"
                                                    }
                                                ],
                                                selected: lotType,
                                                visibility: [
                                                    "дом",
                                                    "участок"
                                                ].includes(category),
                                                onChange: function(v) {
                                                    setLotType(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                title: "Тип дома",
                                                options: [
                                                    {
                                                        type: "option",
                                                        text: "Доля",
                                                        value: "доля"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Дуплекс",
                                                        value: "дуплекс"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Отдельный дом",
                                                        value: "отдельный дом"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Таунхаус",
                                                        value: "таунхаус"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Часть дома",
                                                        value: "часть дома"
                                                    }
                                                ],
                                                selected: subCategory,
                                                visibility: [
                                                    "дом"
                                                ].includes(category),
                                                multiple: true,
                                                onChange: function(v) {
                                                    setSubCategory(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                title: "Тип входа",
                                                checkboxes: [
                                                    {
                                                        text: "Общий",
                                                        value: "общий"
                                                    },
                                                    {
                                                        text: "Отдельный",
                                                        value: "отдельный"
                                                    }
                                                ],
                                                selected: entrance,
                                                visibility: [
                                                    "коммерция"
                                                ].includes(category),
                                                single: true,
                                                onChange: function(v) {
                                                    setEntrance(v[0]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                title: "Тип здания",
                                                options: [
                                                    {
                                                        type: "option",
                                                        text: "Бизнес-центр",
                                                        value: "бизнес-центр"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Встроенное помещение",
                                                        value: "встроенное помещение"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Отдельно стоящее здание",
                                                        value: "отдельно стоящее здание"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Складской комплекс",
                                                        value: "складской комплекс"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Торговый центр",
                                                        value: "Торговый центр"
                                                    }
                                                ],
                                                selected: commercialBuildingType,
                                                visibility: [
                                                    "коммерция"
                                                ].includes(category),
                                                multiple: true,
                                                onChange: function(v) {
                                                    setCommercialBuildingType(v);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterActions),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                        className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().moreFiltersButton),
                                        type: "button",
                                        onClick: function() {
                                            return setIsMoreVisible(!isMoreVisible);
                                        },
                                        children: [
                                            isMoreVisible ? "Свернуть фильтры" : "Дополнительные фильтры",
                                            moreFiltersCount > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                children: moreFiltersCount
                                            })
                                        ]
                                    }),
                                    filtersCount > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().resetButton),
                                        color: "red",
                                        onClick: handleResetClick,
                                        style: {
                                            marginLeft: "auto"
                                        },
                                        children: "Очистить"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().searchButton),
                                        color: "green",
                                        onClick: handleSearchClick,
                                        loading: isLoading,
                                        children: foundCount > 0 ? "Показать ".concat(foundCount, " ").concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .declOfNum */ .Ak)(foundCount, [
                                            "объект",
                                            "объекта",
                                            "объектов"
                                        ])) : "Найти"
                                    })
                                ]
                            })
                        ]
                    }),
                    isAnyFilters(objectsState.filter) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterActiveList),
                        children: [
                            Object.keys(objectsState.filter).map(function(value, index) {
                                if (Array.isArray(objectsState.filter[value]) && !objectsState.filter[value].length || !objectsState.filter[value] || [
                                    "type",
                                    "category"
                                ].includes(value) || !_data_filters_json__WEBPACK_IMPORTED_MODULE_15__[value]) return false;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterActiveItem),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                _data_filters_json__WEBPACK_IMPORTED_MODULE_15__[value],
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: valueToNormal(value, objectsState.filter[value])
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                            type: "button",
                                            title: "Удалить фильтр",
                                            onClick: function() {
                                                eval("set".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .capitalizeFirstLetter */ .fm)(value), "(").concat((0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .valueToZero */ .lS)(objectsState.filter[value]), ")"));
                                                setObjectsState({
                                                    type: "SET_FILTER",
                                                    payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, objectsState.filter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, value, (0,_helpers__WEBPACK_IMPORTED_MODULE_9__/* .valueToZero */ .lS)(objectsState.filter[value])))
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "20",
                                                height: "20",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("line", {
                                                        x1: "18",
                                                        y1: "6",
                                                        x2: "6",
                                                        y2: "18"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("line", {
                                                        x1: "6",
                                                        y1: "6",
                                                        x2: "18",
                                                        y2: "18"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_styles_modules_objects_ObjectsFilter_module_scss__WEBPACK_IMPORTED_MODULE_19___default().filterActiveItemDummy)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ObjectsFilter);


/***/ }),

/***/ 4111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _region_objects; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./context/objects.js
var objects = __webpack_require__(1563);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./components/Header.js + 4 modules
var Header = __webpack_require__(798);
// EXTERNAL MODULE: ./components/Button.js
var components_Button = __webpack_require__(2077);
// EXTERNAL MODULE: ./components/Splitter.js
var Splitter = __webpack_require__(2040);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 173 modules
var motion = __webpack_require__(8548);
// EXTERNAL MODULE: ./context/location.js
var context_location = __webpack_require__(637);
// EXTERNAL MODULE: ./hooks/useIsMount.js
var useIsMount = __webpack_require__(9766);
// EXTERNAL MODULE: ./helpers/index.js
var helpers = __webpack_require__(3725);
// EXTERNAL MODULE: ./components/Skelet.js
var Skelet = __webpack_require__(3177);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(5820);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(5518);
// EXTERNAL MODULE: ./styles/modules/objects/ObjectsCatalogSort.module.scss
var ObjectsCatalogSort_module = __webpack_require__(1234);
var ObjectsCatalogSort_module_default = /*#__PURE__*/__webpack_require__.n(ObjectsCatalogSort_module);
;// CONCATENATED MODULE: ./public/images/sort.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.86 3.29h11a1 1 0 0 0 0-2h-11a1 1 0 0 0 0 2ZM11.86 7.17h7.77a1 1 0 0 0 0-2h-7.77a1 1 0 0 0 0 2ZM22.82 9.06h-11a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2ZM11.86 14.94h7.77a1 1 0 0 0 0-2h-7.77a1 1 0 0 0 0 2ZM22.82 16.83h-11a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2ZM19.63 20.71h-7.77a1 1 0 0 0 0 2h7.77a1 1 0 1 0 0-2ZM7.38 5.48a1 1 0 0 0 .72.3 1 1 0 0 0 .69-.28 1 1 0 0 0 0-1.41L5.51.65A1 1 0 0 0 4.8.34a1.13 1.13 0 0 0-.71.28L.52 4.06a1 1 0 0 0 0 1.42 1 1 0 0 0 1.41 0l1.73-1.67v16.55l-1.72-1.78a1 1 0 0 0-1.42 0A1 1 0 0 0 .5 20l3.31 3.4a1 1 0 0 0 .7.31 1 1 0 0 0 .7-.28L8.8 20a1 1 0 0 0 0-1.42 1 1 0 0 0-1.41 0l-1.73 1.65V3.69Z"
  })));
};
/* harmony default export */ var sort = (SvgSort);
;// CONCATENATED MODULE: ./components/objects/ObjectsCatalogSort.js








var ObjectsCatalogSort = function(param) {
    var content = param.content;
    /** STATES */ var setObjectsState = (0,objects/* useObjectsDispatch */.U_)();
    var ref = (0,react.useState)(false), isVisible = ref[0], setVisibility = ref[1];
    var ref1 = (0,react.useState)(content.filter(function(value) {
        return value.selected;
    })[0]), selected = ref1[0], setSelected = ref1[1];
    /** REFS */ var parentEl = (0,react.useRef)(null);
    var selectEl = (0,react.useRef)(null);
    /** HANDLERS */ var handleOutsideClick = function(e) {
        if (e.target.closest(".".concat((ObjectsCatalogSort_module_default()).sort)) !== parentEl.current) setVisibility(false);
    };
    /** HOOKS */ (0,react.useEffect)(function() {
        document.body.addEventListener("click", handleOutsideClick);
        return function() {
            return document.body.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    /** TEMPLATES */ if (lib/* isMobile */.tq) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        ref: parentEl,
        type: "button",
        className: (ObjectsCatalogSort_module_default()).sort,
        onClick: function() {
            return selectEl.current.focus();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                ref: selectEl,
                onChange: function(e) {
                    var selectedOption = (0,_to_consumable_array/* default */.Z)(e.target.options).filter(function(x) {
                        return x.selected;
                    })[0];
                    var groupedSelected = {
                        text: selectedOption.innerText,
                        sort: selectedOption.value,
                        direction: selectedOption.dataset.direction
                    };
                    setSelected(groupedSelected);
                    setObjectsState({
                        type: "SET_PAGINATION",
                        payload: {
                            page: 1
                        }
                    });
                    setObjectsState({
                        type: "SET_SORTING",
                        payload: {
                            sort: groupedSelected.sort,
                            sortDirection: groupedSelected.direction
                        }
                    });
                },
                children: content.map(function(value, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        "data-direction": value.direction,
                        value: value.sort,
                        defaultValue: value.selected ? "selected" : null,
                        children: value.text
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ObjectsCatalogSort_module_default()).sortShowcase,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ObjectsCatalogSort_module_default()).sortText,
                        children: selected.text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sort, {})
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: parentEl,
        className: (ObjectsCatalogSort_module_default()).sort,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ObjectsCatalogSort_module_default()).sortShowcase,
                role: "button",
                tabIndex: 0,
                onClick: function() {
                    return setVisibility(!isVisible);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ObjectsCatalogSort_module_default()).sortText,
                        children: selected.text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sort, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: {
                        opacity: 0,
                        y: 12
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    exit: {
                        opacity: 0,
                        y: 12,
                        transition: {
                            duration: 0.2
                        }
                    },
                    className: (ObjectsCatalogSort_module_default()).sortPicker,
                    children: content.map(function(value, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: [
                                (ObjectsCatalogSort_module_default()).sortElement,
                                value.sort === selected.sort && value.direction === selected.direction ? (ObjectsCatalogSort_module_default()).selected : null
                            ].join(" "),
                            onClick: function(e) {
                                setVisibility(false);
                                if (!e.target.classList.contains((ObjectsCatalogSort_module_default()).selected)) {
                                    setSelected(value);
                                    setObjectsState({
                                        type: "SET_PAGINATION",
                                        payload: {
                                            page: 1
                                        }
                                    });
                                    setObjectsState({
                                        type: "SET_SORTING",
                                        payload: {
                                            sort: value.sort,
                                            sortDirection: value.direction
                                        }
                                    });
                                }
                            },
                            children: value.text
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var objects_ObjectsCatalogSort = (ObjectsCatalogSort);

// EXTERNAL MODULE: ./components/objects/ObjectsCatalogSkeletonItem.js
var ObjectsCatalogSkeletonItem = __webpack_require__(8171);
// EXTERNAL MODULE: ./components/Input.js
var components_Input = __webpack_require__(1121);
;// CONCATENATED MODULE: ./components/objects/ObjectsCatalogCommercialItem.js








var Modal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2280).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var ObjectsCatalogCommercialItem = function() {
    /** STATES */ var locationState = useLocationState();
    var ref = useState(false), isModalFeedbackVisible = ref[0], setIsModalFeedbackVisible = ref[1];
    var ref1 = useState(false), isModalSuccessVisible = ref1[0], setIsModalSuccessVisible = ref1[1];
    var ref2 = useState(""), clientName = ref2[0], setClientName = ref2[1];
    var ref3 = useState(""), clientPhone = ref3[0], setClientPhone = ref3[1];
    var clientNameId = useRef();
    var clientPhoneId = useRef();
    /** HANDLERS */ var handleFormSubmit = function() {
        clientNameId.current.setError(clientName.length <= 3);
        clientPhoneId.current.setError(clientPhone.length !== 11);
        if (clientName.length > 3 && clientPhone.length === 11) {
            setIsModalCallVisible(false);
            setIsModalSuccessVisible(true);
            axios.post("https://baza.estate/api/v2" + "/client", {
                clientName: clientName,
                clientPhone: clientPhone,
                pathName: window.location.pathname,
                whatComponent: "ObjectsCatalogCommercialItem",
                location: locationState.region,
                platform: "web"
            });
        }
    };
    /** TEMPLATE */ return /*#__PURE__*/ _jsxs("div", {
        className: css.commercial,
        children: [
            /*#__PURE__*/ _jsxs(Modal, {
                title: "Заявка на подбор",
                visibility: isModalSuccessVisible,
                onClose: function() {
                    return setIsModalSuccessVisible(false);
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            marginBottom: 18
                        },
                        children: "Спасибо за вашу заявку. Мы скоро с Вами свяжемся!"
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "/images/man-with-message.svg",
                        alt: "",
                        style: {
                            margin: 32
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                title: "Заявка на подбор",
                button: "Отправить",
                action: handleFormSubmit,
                visibility: isModalFeedbackVisible,
                onClose: function() {
                    return setIsModalFeedbackVisible(false);
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            marginBottom: 18
                        },
                        children: "Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, подберем лучшие объекты!"
                    }),
                    /*#__PURE__*/ _jsx(Input, {
                        title: "Имя",
                        inputs: [
                            {
                                placeholder: "Иван Петрович",
                                value: clientName,
                                type: "text"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientNameId,
                        onChange: function(v) {
                            return setClientName(v[0]);
                        }
                    }),
                    /*#__PURE__*/ _jsx(Input, {
                        title: "Телефон",
                        inputs: [
                            {
                                placeholder: locationState.phone,
                                value: clientPhone,
                                mask: "phone",
                                type: "tel"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientPhoneId,
                        onChange: function(v) {
                            return setClientPhone(v[0]);
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            textAlign: "center",
                            opacity: 0.8,
                            fontSize: 14,
                            margin: "18px 0"
                        },
                        children: [
                            "Вы соглашаетесь с",
                            " ",
                            /*#__PURE__*/ _jsx("a", {
                                href: "/faq/policy",
                                target: "_blank",
                                children: "политикой конфиденциальности"
                            }),
                            " ",
                            "при отправке данной формы к нам в работу"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                color: "white",
                style: {
                    fontSize: 18,
                    fontWeight: 600,
                    padding: "12px 18px",
                    flexShrink: 0
                },
                onClick: function() {
                    return setIsModalFeedbackVisible(true);
                },
                children: "Подобрать варианты"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: css.commercialContent,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: css.comemrcialTitle,
                        children: "Не нашли подходящего варианта?"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: css.comemrcialDescription,
                        children: "Оставьте заявку на подбор объекта из закрытой базы нашим специалистам!"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var objects_ObjectsCatalogCommercialItem = ((/* unused pure expression or super */ null && (ObjectsCatalogCommercialItem)));

// EXTERNAL MODULE: ./styles/modules/objects/ObjectsCatalog.module.scss
var ObjectsCatalog_module = __webpack_require__(1722);
var ObjectsCatalog_module_default = /*#__PURE__*/__webpack_require__.n(ObjectsCatalog_module);
;// CONCATENATED MODULE: ./public/images/map.svg
var map_path, _path2;
function map_extends() { map_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return map_extends.apply(this, arguments); }

var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/react.createElement("svg", map_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    strokeWidth: 2
  }, props), map_path || (map_path = /*#__PURE__*/react.createElement("path", {
    d: "m23.57 22.27-2.89-6a1 1 0 0 0-.9-.57h-3.45c1.64-2.5 3.23-5.43 3.23-7.4a7.56 7.56 0 1 0-15.11 0c0 2 1.59 4.9 3.23 7.4H4.23a1 1 0 0 0-.9.57l-2.89 6a1 1 0 0 0 0 1 1 1 0 0 0 .85.47h21.38a1 1 0 0 0 .85-.47 1 1 0 0 0 .05-1ZM6.45 8.33a5.56 5.56 0 1 1 11.11 0c0 1.7-1.85 4.81-3.66 7.4-.23.35-.47.68-.7 1s-.51.69-.75 1-.31.4-.45.59l-.45-.59c-.24-.31-.48-.65-.74-1s-.47-.65-.7-1C8.3 13.14 6.45 10 6.45 8.33ZM2.93 21.71l1.93-4h4.2c1 1.46 1.93 2.54 2.17 2.83a1 1 0 0 0 .77.37 1 1 0 0 0 .78-.37c.23-.29 1.12-1.37 2.17-2.83h4.2l1.93 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12 4.81a3.79 3.79 0 1 0 3.79 3.79A3.79 3.79 0 0 0 12 4.81Zm0 5.58a1.79 1.79 0 1 1 1.79-1.79A1.79 1.79 0 0 1 12 10.39Z"
  })));
};
/* harmony default export */ var map = (SvgMap);
;// CONCATENATED MODULE: ./components/objects/ObjectsCatalog.js






















var generatePagination = function(current, last) {
    var delta = 1;
    var left = current - delta;
    var right = current + delta + 1;
    var range = [];
    var rangeWithDots = [];
    var l;
    for(var i = 1; i <= last; i += 1){
        if (i === 1 || i === last || i >= left && i < right) {
            range.push(i);
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint-disable-next-line no-restricted-syntax
        for(var _iterator = range[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i1 = _step.value;
            if (l) {
                if (i1 - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (i1 - l !== 1) {
                    rangeWithDots.push(null);
                }
            }
            rangeWithDots.push(i1);
            l = i1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rangeWithDots;
};
var ObjectsCatalogItem = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3012), __webpack_require__.e(1303)]).then(__webpack_require__.bind(__webpack_require__, 3259));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3259)
            ];
        }
    },
    suspense: true
});
var ObjectsCatalog = function() {
    /** STATES */ var router = (0,next_router.useRouter)();
    var isMount = (0,useIsMount/* useIsMount */.z)();
    var locationState = (0,context_location/* useLocationState */.KJ)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,objects/* useObjectsProvider */.v8)(), 2), objectsState = ref[0], setObjectsState = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isLoadingData = ref2[0], setIsLoadingData = ref2[1];
    var ref3 = (0,react.useState)(false), isError = ref3[0], setIsError = ref3[1];
    var ref4 = (0,react.useState)(null), data = ref4[0], setData = ref4[1];
    var ref5 = (0,react.useState)(null), total = ref5[0], setTotal = ref5[1];
    var ref6 = (0,react.useState)(null), page = ref6[0], setPage = ref6[1];
    var ref7 = (0,react.useState)(null), pages = ref7[0], setPages = ref7[1];
    /** HANDLERS AND FUNCTIONS */ var handlePagingClick = function(value) {
        var modificator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (value + modificator === page || value + modificator <= 0 || value + modificator > pages) return;
        setPage(value + modificator);
        setObjectsState({
            type: "SET_PAGINATION",
            payload: {
                page: value + modificator
            }
        });
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var isSortSelected = function(sort, dir) {
        if (!sort) return false;
        if (objectsState.sorting.sort === sort) {
            if (dir) {
                if (objectsState.sorting.sortDirection === dir) return true;
                return false;
            }
            return true;
        }
        return false;
    };
    var handleMoveToMap = function() {
        router.push("/".concat(locationState.code, "/objects/map").concat((0,helpers/* JSONToQuery */.vp)((0,_object_spread/* default */.Z)({}, objectsState.filter, objectsState.pagination, objectsState.sorting), [
            "length",
            objectsState.filter.studio && !objectsState.filter.rooms.length && "studio",
            !objectsState.filter.studio && objectsState.filter.rooms.length === 1 && "rooms"
        ], [
            "page=1",
            "sort=last-update.date"
        ])), undefined, {
            scroll: false
        });
    };
    /** HOOKS */ (0,react.useEffect)(function() {
        if (!locationState.isLoaded) return;
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setIsLoading(true);
                            _ctx.next = 4;
                            return (0,helpers/* sleep */._v)(300);
                        case 4:
                            _ctx.next = 6;
                            return axios_default().post("https://baza.estate/api/v2" + "/objects", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter, objectsState.sorting, objectsState.pagination), {
                                location: locationState.region
                            }), {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setTotal(response.data.data.total);
                            setPage(response.data.data.current_page);
                            setPages(response.data.data.last_page);
                            setData(response.data.data.data);
                            setIsLoading(false);
                            setIsError(false);
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            if (_ctx.t0.code !== "ERR_CANCELED") {
                                setIsLoading(false);
                                setIsError(true);
                            }
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        objectsState.filter,
        locationState
    ]);
    (0,react.useEffect)(function() {
        if (!locationState.isLoaded || isMount || isLoading) return;
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setIsLoadingData(true);
                            _ctx.next = 4;
                            return (0,helpers/* sleep */._v)(300);
                        case 4:
                            _ctx.next = 6;
                            return axios_default().post("https://baza.estate/api/v2" + "/objects", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter, objectsState.sorting, objectsState.pagination), {
                                location: locationState.region
                            }), {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setPage(response.data.data.current_page);
                            setData(response.data.data.data);
                            setIsLoadingData(false);
                            setIsError(false);
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            if (_ctx.t0.code !== "ERR_CANCELED") {
                                setIsLoadingData(false);
                                setIsError(true);
                            }
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        objectsState.pagination
    ]);
    (0,react.useEffect)(function() {
        return window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        locationState
    ]);
    /** TEMPLATES */ if (isLoading || isError) return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: [
            "block",
            (ObjectsCatalog_module_default()).clear
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: [
                "fixed",
                (ObjectsCatalog_module_default()).catalog
            ].join(" "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ObjectsCatalog_module_default()).catalogHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                            height: 32,
                            maxWidth: 400,
                            className: (ObjectsCatalog_module_default()).catalogHeaderTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                            height: 32,
                            maxWidth: 200,
                            className: (ObjectsCatalog_module_default()).catalogHeaderActions
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ObjectsCatalog_module_default()).catalogContent,
                    children: (0,_to_consumable_array/* default */.Z)(Array(3).keys()).map(function(value) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsCatalogSkeletonItem/* default */.Z, {}, value);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                    height: 48,
                    maxWidth: 300,
                    className: (ObjectsCatalog_module_default()).catalogFooter,
                    style: {
                        margin: "auto"
                    }
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: [
            "block",
            (ObjectsCatalog_module_default()).clear
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: [
                "fixed",
                (ObjectsCatalog_module_default()).catalog
            ].join(" "),
            children: [
                data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ObjectsCatalog_module_default()).catalogHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ObjectsCatalog_module_default()).catalogHeaderTitle,
                            children: [
                                (0,helpers/* declOfNum */.Ak)(total, [
                                    objectsState.filter.category === "дом" || objectsState.filter.category === "участок" ? "Найден" : "Найдена",
                                    "Найдено",
                                    "Найдено"
                                ]),
                                " ",
                                total,
                                " ",
                                (0,helpers/* categoryCaseConverter */.J5)(objectsState.filter.category, total),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        " в ",
                                        locationState.case
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ObjectsCatalog_module_default()).catalogHeaderActions,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: (ObjectsCatalog_module_default()).catalogMapButton,
                                    onClick: handleMoveToMap,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                marginRight: 8
                                            },
                                            children: "На карте"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(map, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsCatalogSort, {
                                    content: [
                                        {
                                            text: "По дате публикации",
                                            sort: "last-update.date",
                                            selected: isSortSelected("last-update.date")
                                        },
                                        {
                                            text: "Сначала дешевле",
                                            sort: "price.value",
                                            direction: "asc",
                                            selected: isSortSelected("price.value", "asc")
                                        },
                                        {
                                            text: "Сначала дороже",
                                            sort: "price.value",
                                            direction: "desc",
                                            selected: isSortSelected("price.value", "desc")
                                        }
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ObjectsCatalog_module_default()).catalogContent,
                    children: isLoadingData ? (0,_to_consumable_array/* default */.Z)(Array(3).keys()).map(function(value) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsCatalogSkeletonItem/* default */.Z, {}, value);
                    }) : data.length > 0 ? data.map(function(value, index) {
                        if (data.length > 4 && index === 3) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsCatalogSkeletonItem/* default */.Z, {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsCatalogItem, {
                                        item: value
                                    })
                                })
                            }, index);
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsCatalogSkeletonItem/* default */.Z, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsCatalogItem, {
                                item: value
                            })
                        }, index);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                        initial: {
                            opacity: 0,
                            scale: 0.5
                        },
                        animate: {
                            opacity: 1,
                            scale: 1,
                            transition: {
                                duration: 1,
                                type: "spring",
                                bounce: 0.6
                            }
                        },
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                style: {
                                    marginBottom: 8
                                },
                                children: [
                                    "Нет вариантов в ",
                                    locationState.case
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    opacity: 0.6,
                                    textAlign: "center",
                                    margin: "0 18px"
                                },
                                children: "Попробуйте изменить фильтры или расширить область поиска"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/no_results.svg",
                                alt: "",
                                style: {
                                    width: "100%",
                                    maxWidth: 400,
                                    margin: "18px 32px"
                                }
                            })
                        ]
                    })
                }),
                pages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ObjectsCatalog_module_default()).catalogFooter,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (ObjectsCatalog_module_default()).catalogFooterLeft,
                            type: "button",
                            "aria-label": "Предыдущая страница",
                            onClick: function() {
                                return handlePagingClick(page, -1);
                            },
                            style: {
                                cursor: page <= 1 ? "not-allowed" : null,
                                opacity: page <= 1 ? 0.1 : null
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                    points: "15 18 9 12 15 6"
                                })
                            })
                        }),
                        generatePagination(page, pages).map(function(value, index) {
                            if (!value) return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "..."
                            }, index);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: [
                                    (ObjectsCatalog_module_default()).catalogFooterButton,
                                    value === page ? (ObjectsCatalog_module_default()).active : ""
                                ].join(" "),
                                type: "button",
                                onClick: function() {
                                    return handlePagingClick(value);
                                },
                                style: {
                                    cursor: value === page ? "default" : null
                                },
                                children: value
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (ObjectsCatalog_module_default()).catalogFooterRight,
                            type: "button",
                            "aria-label": "Следующая страница",
                            onClick: function() {
                                return handlePagingClick(page, 1);
                            },
                            style: {
                                cursor: page >= pages ? "not-allowed" : null,
                                opacity: page >= pages ? 0.1 : null
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                    points: "9 18 15 12 9 6"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var objects_ObjectsCatalog = (ObjectsCatalog);

// EXTERNAL MODULE: ./components/objects/ObjectsFilter.js
var ObjectsFilter = __webpack_require__(1247);
// EXTERNAL MODULE: ./components/objects/ObjectsFilterMobile.js
var ObjectsFilterMobile = __webpack_require__(1568);
// EXTERNAL MODULE: ./styles/modules/objects/Objects.module.scss
var Objects_module = __webpack_require__(3679);
var Objects_module_default = /*#__PURE__*/__webpack_require__.n(Objects_module);
;// CONCATENATED MODULE: ./pages/[region]/objects/index.js



















var ObjectsSEO = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5338).then(__webpack_require__.bind(__webpack_require__, 5338));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5338)
            ];
        }
    }
});
var isAnyFilters = function(s) {
    var arrFilters = [
        "priceFrom",
        "priceTo",
        "rooms",
        "studio",
        "squareFrom",
        "squareTo",
        "mikroraion",
        "locality",
        "squareAreaFrom",
        "squareAreaTo",
        "commercialType",
        "squareLivingFrom",
        "squareLivingTo",
        "squareKitchenFrom",
        "squareKitchenTo",
        "floorFrom",
        "floorTo",
        "floorsFrom",
        "floorsTo",
        "ceiling",
        "balcony",
        "renovation",
        "bathroom",
        "buildingType",
        "stock",
        "lotType",
        "subCategory",
        "entrance",
        "commercialBuildingType"
    ];
    var filtersTotal = 0;
    for(var i = 0; i < arrFilters.length; i++)if (s[arrFilters[i]] && (s[arrFilters[i]].length || s[arrFilters[i]] > 0)) filtersTotal++;
    return filtersTotal > 0;
};
var categoryToSEO = function(c) {
    switch(c){
        default:
        case "flats":
            return "Квартиры";
        case "rooms":
            return "Комнаты";
        case "houses":
            return "Дома";
        case "sites":
            return "Участки";
        case "commercial":
            return "Коммерция";
    }
};
var flatsToSEO = function(f) {
    switch(f){
        case "studio":
            return "Студии";
        default:
        case "1k":
            return "1-комнатные";
        case "2k":
            return "2-комнатные";
        case "3k":
            return "3-комнатные";
        case "4k":
            return "4-комнатные";
    }
};
var breadcrumbsGenerator = function(q) {
    var readyBreadcrumbs = [
        {
            position: 1,
            name: "Вторичка",
            item: "https://".concat("baza.estate", "/").concat(q.region, "/objects")
        }
    ];
    if (q.path && q.path.length) {
        /** Type buy/rent */ if (q.path[0]) {
            readyBreadcrumbs.push({
                position: 2,
                name: q.path[0] === "rent" ? "Аренда" : "Продажа",
                item: "https://".concat("baza.estate", "/").concat(q.region, "/objects/").concat(q.path[0])
            });
        }
        /** Category flats/rooms/houses/sites/commercial */ if (q.path[1]) {
            readyBreadcrumbs.push({
                position: 3,
                name: categoryToSEO(q.path[1]),
                item: "https://".concat("baza.estate", "/").concat(q.region, "/objects/").concat(q.path[0], "/").concat(q.path[1])
            });
        }
        /** Rooms count for flats studio/1k/2k/3k/4k */ if (q.path[1] && q.path[1] === "flats" && q.path[2]) {
            readyBreadcrumbs.push({
                position: 4,
                name: flatsToSEO(q.path[2]),
                item: "https://".concat("baza.estate", "/").concat(q.region, "/objects/").concat(q.path[0], "/").concat(q.path[1], "/").concat(q.path[2])
            });
        }
    }
    return readyBreadcrumbs;
};
var ObjectsPage = function(param) {
    var query = param.query, region = param.region;
    /** STATE */ var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,objects/* useObjectsProvider */.v8)(), 2), objectsState = ref[0], setObjectsState = ref[1];
    var locationState = (0,context_location/* useLocationState */.KJ)();
    /** FUNCTIONS */ var getSEOTitle = function() {
        var arrTitle = [];
        /** TYPE */ arrTitle.push(query.path && query.path[0] && query.path[0] === "rent" ? "Снять" : "Купить");
        /** CATEGORY */ if (query.path && query.path[1] && [
            "flats",
            "rooms",
            "houses",
            "sites",
            "commercial"
        ].includes(query.path[1])) {
            switch(query.path[1]){
                default:
                case "flats":
                    if (query.path[2] && [
                        "studio",
                        "1k",
                        "2k",
                        "3k",
                        "4k"
                    ].includes(query.path[2])) {
                        switch(query.path[2]){
                            case "studio":
                                arrTitle.push("квартиру-студию вторичку");
                                break;
                            case "1k":
                                arrTitle.push("однокомнатную квартиру вторичку");
                                break;
                            case "2k":
                                arrTitle.push("двухкомнатную квартиру вторичку");
                                break;
                            case "3k":
                                arrTitle.push("трехкомнатную квартиру вторичку");
                                break;
                            case "4k":
                                arrTitle.push("четырехкомнатную квартиру вторичку");
                                break;
                            default:
                                break;
                        }
                    } else {
                        arrTitle.push("квартиру вторичку");
                    }
                    break;
                case "rooms":
                    arrTitle.push("комнату");
                    break;
                case "houses":
                    arrTitle.push("дом");
                    break;
                case "sites":
                    arrTitle.push("участок");
                    break;
                case "commercial":
                    arrTitle.push("коммерческую недвижимость");
                    break;
            }
        } else {
            arrTitle.push("квартиру вторичку");
        }
        arrTitle.push("в " + locationState.case);
        return arrTitle.join(" ");
    };
    var getSEODescription = function() {
        var arrDescription = [];
        arrDescription.push("".concat(query.path && query.path[0] && query.path[0] === "rent" ? "Аренда" : "Продажа", " вторичного жилья в ").concat(locationState.seo.footer, "."));
        arrDescription.push(query.path && query.path[0] && query.path[0] === "rent" ? "Снять" : "Купить");
        if (query.path && query.path[1] && [
            "flats",
            "rooms",
            "houses",
            "sites",
            "commercial"
        ].includes(query.path[1])) {
            switch(query.path[1]){
                default:
                case "flats":
                    if (query.path[2] && [
                        "studio",
                        "1k",
                        "2k",
                        "3k",
                        "4k"
                    ].includes(query.path[2])) {
                        switch(query.path[2]){
                            case "studio":
                                arrDescription.push("квартиру-студию вторичку");
                                break;
                            case "1k":
                                arrDescription.push("однокомнатную квартиру вторичку");
                                break;
                            case "2k":
                                arrDescription.push("двухкомнатную квартиру вторичку");
                                break;
                            case "3k":
                                arrDescription.push("трехкомнатную квартиру вторичку");
                                break;
                            case "4k":
                                arrDescription.push("четырехкомнатную квартиру вторичку");
                                break;
                            default:
                                break;
                        }
                    } else {
                        arrDescription.push("квартиру вторичку");
                    }
                    break;
                case "rooms":
                    arrDescription.push("комнату");
                    break;
                case "houses":
                    arrDescription.push("дом");
                    break;
                case "sites":
                    arrDescription.push("участок");
                    break;
                case "commercial":
                    arrDescription.push("коммерческую недвижимость");
                    break;
            }
        } else {
            arrDescription.push("квартиру вторичку");
        }
        arrDescription.push("недорого: цены, свежие объявления, срочная продажа.");
        return arrDescription.join(" ");
    };
    var onSortChange = function(e) {
        var selectedOption = (0,_to_consumable_array/* default */.Z)(e.target.options).filter(function(x) {
            return x.selected;
        })[0];
        var groupedSelected = {
            sort: selectedOption.value.split("/")[0],
            direction: selectedOption.value.split("/")[1]
        };
        setObjectsState({
            type: "SET_PAGINATION",
            payload: {
                page: 1
            }
        });
        setObjectsState({
            type: "SET_SORTING",
            payload: {
                sort: groupedSelected.sort,
                sortDirection: groupedSelected.direction
            }
        });
    };
    var openMobileFilters = function() {
        setObjectsState({
            type: "SET_STATE",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.state), {
                isFiltersMobileVisible: true
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: getSEOTitle(),
                description: getSEODescription(),
                openGraph: {
                    url: "https://".concat("baza.estate"),
                    type: "website",
                    title: getSEOTitle(),
                    description: getSEODescription(),
                    images: [
                        {
                            url: "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: breadcrumbsGenerator(query)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                region: region
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "core",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsFilter/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsFilterMobile/* default */.Z, {}),
                    !objectsState.state.isFiltersMobileVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Objects_module_default()).filterMobileActions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Button/* default */.Z, {
                                onClick: openMobileFilters,
                                color: "black",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.7",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Objects_module_default()).filterMobileButtonText,
                                        children: "Фильтры"
                                    }),
                                    isAnyFilters(objectsState.filter) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Objects_module_default()).filterMobileButtonMark
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                                style: {
                                    width: 52,
                                    height: 52,
                                    marginLeft: 4
                                },
                                withShadow: true,
                                color: "yellow",
                                onClick: function() {
                                    return router.push("/".concat(region, "/objects/map"));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            points: "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                            x1: "8",
                                            y1: "2",
                                            x2: "8",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                            x1: "16",
                                            y1: "6",
                                            x2: "16",
                                            y2: "22"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Button/* default */.Z, {
                                style: {
                                    width: 52,
                                    height: 52,
                                    marginLeft: 4
                                },
                                withShadow: true,
                                color: "yellow",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        value: "".concat(objectsState.sorting.sort || "price.value", "/").concat(objectsState.sorting.sortDirection || "price.asc"),
                                        style: {
                                            position: "absolute",
                                            left: 0,
                                            top: 0,
                                            right: 0,
                                            bottom: 0,
                                            opacity: 0
                                        },
                                        onChange: onSortChange,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "last-update.date",
                                                children: "По актуальности"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "price.value/asc",
                                                children: "Цена по возрастанию"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "price.value/desc",
                                                children: "Цена по убыванию"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8 5V19",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M16 19V5",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12 14L8 19L4 14",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12.0039 10L16.0039 5L20.0039 10",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsCatalog, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsSEO, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                region: region,
                seo: getSEOTitle()
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _region_objects = (ObjectsPage);


/***/ }),

/***/ 1102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"splitter":"Splitter_splitter__Mp2tP","text":"Splitter_text__79Zmg","title":"Splitter_title__Fmxhb","subtitle":"Splitter_subtitle__CmYZ2","actions":"Splitter_actions__6lGHR","input":"Splitter_input__2_PBU","inputZone":"Splitter_inputZone__Bj3xv","inputButton":"Splitter_inputButton__efr_F","no-animation":"Splitter_no-animation__2chXz","no-border":"Splitter_no-border__0YEZA","fullWidth":"Splitter_fullWidth__D6CYJ","help":"Splitter_help__Cb_S8"};

/***/ }),

/***/ 1319:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"txt":"Textarea_txt__h9LCE","txtTitle":"Textarea_txtTitle__NdQd9","txtContent":"Textarea_txtContent__t4AHN","full":"Textarea_full__ldXF7","error":"Textarea_error__z_vDn"};

/***/ }),

/***/ 3679:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filterMobileActions":"Objects_filterMobileActions__j9rpk","filterMobileButtonText":"Objects_filterMobileButtonText__edR5w","filterMobileButtonMark":"Objects_filterMobileButtonMark__LrHaM"};

/***/ }),

/***/ 1722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"catalog":"ObjectsCatalog_catalog__Hh2Sr","catalogHeader":"ObjectsCatalog_catalogHeader__k_JRe","catalogHeaderTitle":"ObjectsCatalog_catalogHeaderTitle__zur36","catalogHeaderActions":"ObjectsCatalog_catalogHeaderActions__6U5Cx","catalogMapButton":"ObjectsCatalog_catalogMapButton__5rf1_","catalogHeaderSort":"ObjectsCatalog_catalogHeaderSort__0eJaw","up":"ObjectsCatalog_up__teuFd","catalogContent":"ObjectsCatalog_catalogContent__sC6en","catalogFooter":"ObjectsCatalog_catalogFooter__o_uwj","catalogFooterLeft":"ObjectsCatalog_catalogFooterLeft__jU1rY","catalogFooterRight":"ObjectsCatalog_catalogFooterRight__NwDAl","catalogFooterButton":"ObjectsCatalog_catalogFooterButton__nA2aC","active":"ObjectsCatalog_active__eNktN","clear":"ObjectsCatalog_clear__qMu9y"};

/***/ }),

/***/ 4062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"ObjectsCatalogItem_item__1ZMCX","itemGallery":"ObjectsCatalogItem_itemGallery__NCwCX","itemGalleryCounter":"ObjectsCatalogItem_itemGalleryCounter__gwd2w","itemGalleryButtons":"ObjectsCatalogItem_itemGalleryButtons__VHbxU","itemGalleryButtonLeft":"ObjectsCatalogItem_itemGalleryButtonLeft__zVeXw","itemGalleryButtonRight":"ObjectsCatalogItem_itemGalleryButtonRight__S1vOQ","itemGalleryPhotos":"ObjectsCatalogItem_itemGalleryPhotos__B9SNX","itemGalleryPhoto":"ObjectsCatalogItem_itemGalleryPhoto__gDJpY","itemGalleryPhotoHash":"ObjectsCatalogItem_itemGalleryPhotoHash__INhPB","itemGalleryPhotoMore":"ObjectsCatalogItem_itemGalleryPhotoMore__ive6N","itemGalleryPhotoMoreText":"ObjectsCatalogItem_itemGalleryPhotoMoreText__dOZyX","itemLabels":"ObjectsCatalogItem_itemLabels__IYVcB","itemLabelsItem":"ObjectsCatalogItem_itemLabelsItem__M_Uo_","yellow":"ObjectsCatalogItem_yellow__rYPoE","red":"ObjectsCatalogItem_red__bnkB1","itemData":"ObjectsCatalogItem_itemData__azZrz","itemPrice":"ObjectsCatalogItem_itemPrice__5ZYQA","green":"ObjectsCatalogItem_green__JY1JX","itemActionsFavorites":"ObjectsCatalogItem_itemActionsFavorites__JYrxM","active":"ObjectsCatalogItem_active__GVnm9","itemOldPrice":"ObjectsCatalogItem_itemOldPrice__eV0ML","itemAddress":"ObjectsCatalogItem_itemAddress__6CFms","itemProperties":"ObjectsCatalogItem_itemProperties__ENt9e","itemProperty":"ObjectsCatalogItem_itemProperty__OfsQQ","itemDescription":"ObjectsCatalogItem_itemDescription__tCe7V","itemActions":"ObjectsCatalogItem_itemActions__w6rGN","itemDate":"ObjectsCatalogItem_itemDate__tR0B_","itemFavorites":"ObjectsCatalogItem_itemFavorites__U7fsE","qr":"ObjectsCatalogItem_qr__Z_W4o"};

/***/ }),

/***/ 1234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sort":"ObjectsCatalogSort_sort__57sRf","sortShowcase":"ObjectsCatalogSort_sortShowcase__C1HkF","sortText":"ObjectsCatalogSort_sortText__aXonF","sortPicker":"ObjectsCatalogSort_sortPicker__WtcpP","sortElement":"ObjectsCatalogSort_sortElement__RPmDE","selected":"ObjectsCatalogSort_selected__r8VqF"};

/***/ }),

/***/ 5661:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"ObjectsFilter_block__x5zCZ","filterContainer":"ObjectsFilter_filterContainer__p_1nH","filterWrapper":"ObjectsFilter_filterWrapper__zdlYs","filterGroup":"ObjectsFilter_filterGroup__b_Rih","filterSplit":"ObjectsFilter_filterSplit__VpyRe","filterActions":"ObjectsFilter_filterActions__QN3E0","moreFiltersButton":"ObjectsFilter_moreFiltersButton__XK4YD","resetButton":"ObjectsFilter_resetButton__YpVCQ","searchButton":"ObjectsFilter_searchButton__KAwa9","filterLine":"ObjectsFilter_filterLine__bStCH","filterActiveList":"ObjectsFilter_filterActiveList__YogiD","filterActiveItem":"ObjectsFilter_filterActiveItem__QGR_f","filterActiveItemDummy":"ObjectsFilter_filterActiveItemDummy__woCF_"};

/***/ }),

/***/ 6014:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"type":"Сделка","category":"Категория","priceFrom":"Стоимость от","priceTo":"Стоимость до","rooms":"Комнат","studio":"Комнат","squareFrom":"Площадь от","squareTo":"Площадь до","mikroraion":"Район","locality":"Город","noCommission":"Акция","exclusive":"Акция","squareAreaFrom":"Площадь участка от","squareAreaTo":"Площадь участка до","commercialType":"Назначение объекта","squareLivingFrom":"Жилая площадь от","squareLivingTo":"Жилая площадь до","squareKitchenFrom":"Площадь кухни от","squareKitchenTo":"Площадь кухни до","floorFrom":"Этаж от","floorTo":"Этаж до","floorsFrom":"Этажей от","floorsTo":"Этажей до","ceiling":"Потолок","balcony":"Балкон","renovation":"Ремонт","bathroom":"Санузел","buildingType":"Стены дома","stock":"Здание","lotType":"Участок","subCategory":"Дом","entrance":"Вход","commercialBuildingType":"Здание","deadlineQuartal":"Квартал сдачи","deadlineYear":"Год сдачи"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41,2962,5518,798,3193,360,1034,9774,2888,179], function() { return __webpack_exec__(3629); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);